/* Minimal carousel: scroll-snap track + dots + arrows.
   Active dot reflects scroll position. Arrows scroll one slide. */
class EventCarousel extends HTMLElement {
  connectedCallback() {
    this.track = this.querySelector('.event-carousel__track');
    this.dots = Array.from(this.querySelectorAll('.event-carousel__dot'));
    this.arrows = Array.from(this.querySelectorAll('[data-direction]'));
    if (!this.track) return;

    this._onScroll = this._onScroll.bind(this);
    this.track.addEventListener('scroll', this._onScroll, { passive: true });

    this.dots.forEach((dot, i) => {
      dot.addEventListener('click', () => this.goTo(i));
    });
    this.arrows.forEach((btn) => {
      btn.addEventListener('click', () => {
        const dir = btn.dataset.direction === 'next' ? 1 : -1;
        const w = this._slideWidth();
        this.track.scrollBy({ left: w * dir, behavior: 'smooth' });
      });
    });

    this._update();
  }

  _slideWidth() {
    const first = this.track.firstElementChild;
    return first ? first.getBoundingClientRect().width : 1;
  }

  _onScroll() {
    if (this._raf) return;
    this._raf = requestAnimationFrame(() => {
      this._raf = null;
      this._update();
    });
  }

  _update() {
    const idx = Math.round(this.track.scrollLeft / this._slideWidth());
    this.dots.forEach((d, i) => d.classList.toggle('is-active', i === idx));
  }

  goTo(index) {
    this.track.scrollTo({ left: this._slideWidth() * index, behavior: 'smooth' });
  }
}

if (!customElements.get('event-carousel')) {
  customElements.define('event-carousel', EventCarousel);
}
